export default {
    unassign_drivers_title: "Unassign Drivers",
    unassign_drivers_account_from: "Account From",
    unassign_drivers_account_to: "Account To",
    unassign_drivers_keyfobs: "DriverID Tags",
    unassign_drivers_input: "ID#'s",
    unassign_drivers_identifier: "Identifier",
    unassign_drivers_account: "Account",
    unassign_drivers_driver: "Driver",
    unassign_drivers_model: "Model",
    unassign_drivers_change: "Unassign",
    unassign_drivers_no_devices_added: "No DriverID Tag added",
    unassign_drivers_device_is_already_added: "The DriverID Tag is already unassigned",
    unassign_drivers_device_has_not_been_found: "The DriverID Tag has not been found",
    unassign_drivers_this_feature_is_not_available: "This feature is not available",
    unassign_drivers_single_success_message: "The DriverID Tag has been unassigned",
    unassign_drivers_multiple_success_message: "The DriverID Tags has been unassigned",
    unassign_drivers_error_message: "Unable to unassign the DriverID Tags due to an error",
    unassign_drivers_select_to_account: "Select the account destination first",
    unassign_drivers_restriction_to_move: "You cannot unassign DriverID Tags to accounts that are not active",
    unassign_drivers_confirm: "Do you want to unassign the drivers from the selected driverId tags?",
}

